import React, { useContext } from "react";
import { CommonDropdown } from "./CommonDropdown";
import { string, func } from "prop-types";
import { useTextDomainContext } from "@/app/providers";

export const SegmentDropDown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = [
    // {
    //   value: "y",
    //   label: gettext("Yearly")
    // },
    {
      value: "m",
      label: gettext("Monthly"),
    },
    {
      value: "d",
      label: gettext("Daily"),
    },
    {
      value: "h",
      label: gettext("Hourly"),
    },
  ];
  const propsDefault = {
    componentLabel: gettext("List as"),
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <CommonDropdown
      options={
        options as unknown as import("@/types/Dropdown.types").DropdownOption[]
      }
      componentLabel={componentLabel}
      showAll={false}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    />
  );
};

SegmentDropDown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  onChange: func,
};
